import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { connectableObservableDescriptor } from 'rxjs/observable/ConnectableObservable';

interface PrivacyUrls {
  informativeNote: string;
  informativeNotePrivacy: string;
  privacyResearch: string;
  privacySale: string;
}

export class AlgPrivacyService {
  private static monthNamesMap = new Map([
    [1, 'gennaio'],
    [2, 'febbraio'],
    [3, 'marzo'],
    [4, 'aprile'],
    [5, 'maggio'],
    [6, 'giugno'],
    [7, 'luglio'],
    [8, 'agosto'],
    [9, 'settembre'],
    [10, 'ottobre'],
    [11, 'novembre'],
    [12, 'dicembre']
  ]);

  public onbPrivacyUrl$: Observable<PrivacyUrls>;

  constructor() {
    this.onbPrivacyUrl$ = Observable.of(environment.documents)
      .pipe(
        map((documents) => {
          const now = new Date();
          const month = now.getMonth() + 1;
          const monthNumber = String(month).padStart(2, '0');
          const monthName = AlgPrivacyService.monthNamesMap.get(month);
          const { _baseUrl, ...urls} = documents;
          return Object.keys(urls)
            .reduce((transformedUrls, key) => ({
              ...transformedUrls,
              [key]: `${_baseUrl}/${monthNumber}-${monthName}/${urls[key]}`
            }), urls);
        })
      );
  }
}




// WEBPACK FOOTER //
// ./src/app/services/alg-privacy.service.ts